import { getValidationErrorsByLineItem } from '../../utils/get-validation-errors-by-line-item.js';
import { toVisualLineItem } from './visual-line-item/cart-line-item.js';
import { lineItemDataMapper } from '../../utils/line-item-data-mapper.js';
import { getCartPrices } from '../../utils/get-cart-prices.js';
import { getDiscountDescriptions } from '../../utils/get-discount-descriptions.js';
import { getActiveVoucherCodes, getActiveVoucherNames } from '../../utils/get-active-voucher-codes.js';
import { getSubscriptionDetails } from '../../utils/get-subscription-details.js';
import { getAddress } from '../../utils/get-address.js';
import { getShippingMethod } from '../../utils/get-shipping-method.js';
import { getCustomerDetails } from '../../utils/get-customer-details.js';
import { createContainsHelper } from '../../utils/create-contains-helper.js';

const toCartView = (cart, validationErrors, settings, intl, apiUrl)=>{
    const lineItemsRaw = cart.lineItems;
    const lineItems = lineItemDataMapper(lineItemsRaw, settings, intl);
    const visualLineItems = lineItemsRaw.map((lineItemRaw)=>toVisualLineItem(lineItemRaw, intl, settings, apiUrl)
    ).filter((lineItem)=>Boolean(lineItem)
    );
    return {
        id: cart.id,
        numberOfItems: cart.numberOfItems,
        lineItems,
        visualLineItems,
        hasSubscription: cart.hasSubscription,
        validationErrors: getValidationErrorsByLineItem(validationErrors),
        additionalCartCostLineItems: cart.additionalCartCostLineItems,
        prices: getCartPrices(cart.price, cart.shippingMethod),
        discountDescriptions: getDiscountDescriptions(cart.appliedDiscounts, intl.locale),
        voucherCodes: getActiveVoucherCodes(cart.vouchers),
        voucherNames: getActiveVoucherNames(cart.vouchers),
        subscription: getSubscriptionDetails(cart),
        isAccountRequired: !!cart.isAccountRequired,
        billingAddress: getAddress(cart.billingAddress),
        shippingAddress: getAddress(cart.shippingAddress),
        shippingMethod: getShippingMethod(cart.shippingMethod),
        customerDetails: getCustomerDetails(cart.customerDetails),
        checkoutState: cart.checkoutState,
        serviceStore: cart.serviceStore ? {
            code: cart.serviceStore.code.toString()
        } : undefined,
        loyaltyDetails: {
            cardNumber: cart.loyaltyDetails.cardNumber || null,
            points: cart.loyaltyDetails.points
        },
        contains: createContainsHelper(lineItems)
    };
};

export { toCartView };
//# sourceMappingURL=to-cart-view.js.map
